// MASSERIA DIGITAL JS - Conversion
document.addEventListener('DOMContentLoaded', function(){
  // FAQ toggle
  document.querySelectorAll('.md-faq-q').forEach(q=>{
    q.addEventListener('click',()=>{
      q.parentElement.classList.toggle('open');
    });
  });
  // Countdown 72h in announcement
  var bar = document.querySelector('.md-announcement');
  if(bar){
    var end = new Date();
    end.setHours(end.getHours()+72);
    setInterval(function(){
      var diff = end - new Date();
      if(diff<=0) return;
      var h = Math.floor(diff/1000/3600);
      var m = Math.floor(diff/1000/60%60);
      var span = bar.querySelector('span');
      if(span) span.textContent = 'SCADE TRA ' + h + 'H ' + m + 'M - OGGI 197€';
    },60000);
  }
  // Sticky buy on scroll for product page
  var buyBtn = document.querySelector('.md-product-info .md-btn');
  if(buyBtn){
    window.addEventListener('scroll',()=>{
      if(window.scrollY>600){
        buyBtn.style.position='fixed';
        buyBtn.style.bottom='20px';
        buyBtn.style.right='20px';
        buyBtn.style.zIndex='99';
        buyBtn.style.boxShadow='0 10px 30px rgba(0,0,0,.2)';
      }
    });
  }
});
